// Version should not be configurable, so it is one of the few
// environment variables that are injected at build time
/* eslint-disable no-restricted-globals */
export const appVersion = process.env.REACT_APP_VERSION || undefined;
export const appCommit = process.env.REACT_APP_COMMIT || 'local';
/* eslint-enable no-restricted-globals */

export const appUniqueVersion = appVersion && `${appVersion}+${appCommit}`;
